import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: "Roboto",
  fonts: [
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-light-webfont.ttf", fontWeight: 300 },
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-regular-webfont.ttf", fontWeight: 400 },
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-medium-webfont.ttf", fontWeight: 500 },
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bold-webfont.ttf", fontWeight: 600 },
  ],
})

Font.register({
  family: "Roboto-Italic",
  fonts: [
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-lightitalic-webfont.ttf", fontWeight: 300, fontStyle: 'italic' },
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-italic-webfont.ttf", fontWeight: 400, fontStyle: 'italic' },
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-mediumitalic-webfont.ttf", fontWeight: 500, fontStyle: 'italic' },
    { src: "https://cdnjs.cloudflare.com/ajax/libs/ink/3.1.10/fonts/Roboto/roboto-bolditalic-webfont.ttf", fontWeight: 600, fontStyle: 'italic' },
  ],
})

export const styles = StyleSheet.create({
  page: {
    fontFamily: 'Roboto', // Use the registered font
    fontSize: 10,
    paddingTop: 30,
    paddingLeft: 40,
    paddingRight: 40,
    paddingBottom: 30,
    lineHeight: 1.4, // Adjusted for better readability
  },
  documentTitle: {
    fontSize: 16,
    textAlign: 'center',
    marginBottom: 20,
    fontWeight: 'bold',
  },
  sectionTitle: {
    fontSize: 12, // Slightly smaller for sections
    fontWeight: 'bold',
    marginTop: 15,
    marginBottom: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#cccccc',
    paddingBottom: 3,
  },
  subSectionTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    marginTop: 10,
    marginBottom: 5,
  },
  fieldContainer: {
    flexDirection: 'row',
    marginBottom: 5,
    alignItems: 'flex-start', // Align label and value at the start
  },
  fieldLabel: {
    fontWeight: 'bold',
    marginRight: 5,
    //width: '20%', // Adjust as needed to align labels
    flexShrink: 0, // Prevent shrinking
  },
  fieldValue: {
    flex: 1,
    //width: '80%', // Adjust as needed
    borderBottomWidth: 0.5, // Simulate a line for the value
    borderBottomColor: '#000',
    paddingBottom: 1,
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 3,
  },
  checkboxLabel: {
    marginLeft: 5,
  },
  checkboxMark: {
    width: 9,
    height: 9,
    borderWidth: 0.8, // Slightly thinner border for a cleaner look
    borderColor: '#000000',
    justifyContent: 'center', // Center content vertically
    alignItems: 'center', // Center content horizontally
  },
  checkboxText: {
    fontSize: 7, // Adjust font size for 'X' or '•'
    lineHeight: 1, // Ensure it's centered
  },
  indentedSection: {
    marginLeft: 20,
    marginTop: 5,
    marginBottom: 10,
  },
  footerText: {
    fontSize: 8,
    color: 'grey',
    textAlign: 'center',
    marginTop: 20,
  },
  signatureSection: {
    marginTop: 25,
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%', // Ensure it takes full width
  },
  signatureBox: {
    width: '45%',
    marginTop: 10,
    paddingTop: 5,
    borderTopWidth: 1,
    borderTopColor: '#666666',
    alignItems: 'center',
  },
  signatureLabel: {
    fontSize: 8,
    color: '#333333',
    textAlign: 'center',
  },
  disclaimerText: {
    fontFamily: 'Roboto-Italic',
    fontSize: 9,
    marginTop: 20,
    fontStyle: 'italic',
  },
  // Added for the informational boxes in the PDF
  infoBox: {
    borderWidth: 1,
    borderColor: '#ccc',
    padding: 8,
    marginBottom: 10,
    backgroundColor: '#f9f9f9',
  },
  infoText: {
    fontSize: 9,
    marginBottom: 5,
    lineHeight: 1.2,
  },
  smallText: {
    fontSize: 8,
    marginBottom: 5,
    marginLeft: 15, // Indent slightly
  },
  noteText: {
    fontFamily: 'Roboto-Italic',
    fontSize: 8,
    marginTop: 5,
    color: '#555',
    fontStyle: 'italic',
  },
  signatureBlock: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 25,
    marginBottom: 20,
  },
  signatureLineContainer: {
    width: '48%', // Adjust width to fit two signatures side-by-side
    alignItems: 'center',
  },
  signatureLineContainerFinaEmployee: {
    width: '30%', // Adjust width to fit two signatures side-by-side
    alignItems: 'center',
  },
  signatureText: {
    fontSize: 10,
    marginBottom: 10,
    textAlign: 'center',
    borderBottomWidth: 0.5,
    borderBottomColor: '#000',
    width: '100%',
    paddingBottom: 2,
  },
  signatureTextStamp: {
    fontSize: 10,
    marginBottom: 10,
    textAlign: 'center',
    borderBottomWidth: 0.5,
    borderBottomColor: '#000',
    width: '100%',
    paddingBottom: 2,
  },
  // Privacy policy section at the end
  privacySection: {
    marginTop: 20,
    paddingTop: 10,
  },
  privacySectionTitle: {
    fontSize: 11,
    fontWeight: 'bold',
    marginBottom: 8,
  },
  privacyText: {
    fontSize: 9,
    marginBottom: 4,
    lineHeight: 1.3,
  },
  logo:{
    width: 'auto',
    height: 20,
    objectFit: 'contain',
  },
  logoContainer: {
    width: '100%', // Take full width
    flexDirection: 'row', // Enable flexbox
    justifyContent: 'flex-start', // Align content to the left
    marginBottom: 10, // Add some space below the logo
  },
  pageNumbers: {
    position: 'absolute',
    bottom: 20,
    left: 0,
    right: 20,
    textAlign: 'right'
  },
});
